<template>
  <div>
    <portal to="search">
      <search-form :q="q" />
    </portal>
    <router-view></router-view>
    <div class="card mb-3" v-show="visible">
      <div class="card-body pb-0">
        <div class="card-title d-flex align-items-center">
          <strong>API Requests</strong>
          <span class="text-muted ml-auto small" v-if="totalCount >= 0">{{ totalCount.toLocaleString('en-IN') }} results</span>
        </div>

        <div class="table-responsive">
          <b-table
            :show-empty="!isLoading"
            empty-text="There are no records matching your request"
            class="table-layout-fixed"
            :items="apiRequests"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            no-local-sorting
            @row-clicked="onRowClicked"
            @sort-changed="onSortingChanged"
          >
          >
            <template slot="top-row" slot-scope="data">
              <td :colspan="data.columns" class="p-0" style="height: 3px">
                <b-progress :value="100" variant="secondary" animated height="2px" v-if="isLoading" />
              </td>
            </template>
          </b-table>
          <b-pagination-nav
            align="center"
            size="md"
            :link-gen="paginationLink"
            :number-of-pages="totalPages"
            v-model="currentPage"
            :per-page="perPage"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapGetters } from "vuex";

import SearchForm from "@app/components/admin/api_requests/Search";

export default {
  components: {
    SearchForm
  },

  data() {
    return {
      isLoading: false,
      apiRequests: [],
      sortBy: "created_at",
      sortDesc: true,
      totalCount: 0,
      totalPages: null,
      currentPage: null,
      perPage: null,
      fields: [
        {
          key: "id",
          label: "ID",
          sortable: false,
          formatter: (value, key, item) => {
            return item.id;
          }
        },
        {
          key: "client",
          text: "Client",
          sortable: true,
          formatter: (value, key, item) => {
            return item.attributes.client;
          }
        },
        {
          key: "api",
          label: "API",
          sortable: true,
          formatter: (value, key, item) => {
            return item.attributes.api_name;
          }
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
          formatter: (value, key, item) => {
            return item.attributes.status;
          }
        },
        {
          key: "created_at",
          label: "Created At",
          sortable: true,
          formatter: (value, key, item) => {
            return this.$moment(item.attributes.created_at).format("LLL");
          }
        }
      ]
    };
  },

  computed: {
    visible() {
      return this.$route.name === "apiRequestsList";
    },

    sortDirection() {
      return this.sortDesc ? "desc" : "asc";
    },

    q() {
      return this.$route.query.q;
    }
  },

  methods: {
    async fetchApiRequests() {
      this.isLoading = true;
      try {
        const { data } = await axios.get("/api/api_requests", {
          params: this.$route.query
        });
        this.apiRequests = data.data;
        this.totalCount = data.meta.total_count;
        this.currentPage = data.meta.current_page;
        this.limit = data.meta.limit;
        this.totalPages = data.meta.total_pages;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
      }
    },

    paginationLink(pageNum) {
      return {
        name: "apiRequestsList",
        query: {
          q: this.q,
          sort: this.sortBy,
          direction: this.sortDirection,
          page: pageNum
        }
      };
    },

    onRowClicked(item) {
      this.$router.push({
        name: "apiRequestShow",
        params: {
          id: item.id
        }
      });
    },

    onSortingChanged(ctx) {
      this.$router.push({
        name: "apiRequestsList",
        query: {
          q: this.q,
          sort: this.sortBy,
          direction: this.sortDirection
        }
      });
    }
  },

  watch: {
    "$route.query": {
      handler(newVal) {
        if (newVal && this.$route.name === "apiRequestsList") {
          this.fetchApiRequests();
        }
      },

      immediate: true
    }
  }
};
</script>

<style scoped>
>>> .b-table-top-row + tr > td {
  border-top: none;
}

>>> .b-table tbody tr {
  cursor: pointer;
}
</style>
